/**
 * quick-reply-category.ts — Danh mục Trả lời nhanh.
 *
 * Danh mục KHÔNG có bảng riêng: là chữ trên từng câu (`MessageTemplate.category`, máy chủ trả danh sách đã gộp ở GET /quick-replies).
 * Popup "Tạo danh mục" trong form thêm câu chỉ thêm tên vào danh sách chọn; danh mục được lưu cùng câu khi bấm Thêm / Lưu.
 */

/** Khớp backend quick-reply-service.ts (CATEGORY_MAX). */
export const CATEGORY_MAX = 100

/** Bỏ khoảng trắng thừa — giống cách máy chủ chuẩn hoá trước khi lưu. */
export function normalizeCategoryName(raw: string): string {
  return raw.trim().replace(/\s+/g, ' ')
}

/** Danh mục trùng tên (không phân biệt hoa thường / khoảng trắng thừa) — tránh "Chào hỏi" và "chào hỏi" thành hai danh mục. */
export function findCategory(list: string[], name: string): string | undefined {
  const key = normalizeCategoryName(name).toLocaleLowerCase('vi')
  if (!key) return undefined
  return list.find((c) => normalizeCategoryName(c).toLocaleLowerCase('vi') === key)
}

/** Danh sách để chọn = danh mục máy chủ + danh mục vừa tạo + danh mục hiện tại của câu; không trùng, sắp theo tiếng Việt. */
export function categoryOptions(server: string[], created: string[], current?: string | null): string[] {
  const out: string[] = []
  for (const c of [...server, ...created, ...(current ? [current] : [])]) {
    const n = normalizeCategoryName(c)
    if (n && !findCategory(out, n)) out.push(n)
  }
  return out.sort((a, b) => a.localeCompare(b, 'vi'))
}
